import React, { useContext } from 'react';
import { Trans } from '@lingui/react';
import Breadcrumb from '@components/Breadcrumb';
import LanguageContext from '@lib/contexts/languageContext';
import { programTypes } from '@lib/constants';
import { Container } from '@components/layout/Grid';
import { ProgramCategory } from '@gql/generated';

type Props = {
  currentPage: string;
  programCategory?: ProgramCategory;
};

const ProgramsBreadcrumb = (props: Props) => {
  const { currentPage, programCategory = ProgramCategory['Programs'] } = props;
  const lang = useContext(LanguageContext);

  const base_page = {
    displayName: <Trans id={programTypes[programCategory].text} />,
    href: `/${lang}/${programTypes[programCategory].listingPageSlug}`,
  };

  return (
    <Container>
      <Breadcrumb
        links={[
          base_page,
          {
            displayName: currentPage,
          },
        ]}
      />
    </Container>
  );
};

export default ProgramsBreadcrumb;
